
export const initialItemValue = {



    item_title: "yes",
    item_description: "yes",

    make: "yes",
    width: "yes",
    length: "yes",
    thickness: "yes",

    weight_per_feet: "yes",
    weight_per_meter: "yes",
    weight_per_6_meter: "yes",
    weight_per_12_meter: "yes",
    weight_per_pcs: "yes",



    batch_yes: "yes",
    style: "yes",
    brand: "yes",
    color: "yes",
    agent: "yes",
    dealer: "yes",
    item_acc_convertion_yn: "yes",
    item_acc_mixed_yn: "yes",
    item_acc_price_yn: "yes",
    item_acc_remark_upload_yn: "yes",
    item_acc_stock_yn: "yes",
    item_acc_website_yn: "yes",
    size: "yes",
    item_barcode_yn: "yes",
    item_classify_yn: "yes",
    item_gst_per_yn: "yes",
    item_inventory_type_yn: "yes",
    item_pack_type_yn: "yes",
    item_proces_type_yn: "yes",
    item_remark_yn: "yes",
    item_reorder_qty_yn: "yes",
    item_min_qty_yn: "yes",
    item_max_qty_yn: "yes",
    item_warnty_available_yn: "yes",
    item_acc_mul_image_yn: "yes",
    item_acc_batta_yn: "yes"
}

export const initialItemValueSuperAdmin = {




   
    item_title: "yes",
    item_description: "yes",

    make: "yes",
    width: "yes",
    length: "yes",
    thickness: "yes",

    weight_per_feet: "yes",
    weight_per_meter: "yes",
    weight_per_6_meter: "yes",
    weight_per_12_meter: "yes",
    weight_per_pcs: "yes",




    batch_yes: "yes",
    style: "yes",
    brand: "yes",
    color: "yes",
    agent: "yes",
    dealer: "yes",
    item_acc_convertion_yn: "yes",
    item_acc_mixed_yn: "yes",
    item_acc_price_yn: "yes",
    item_acc_remark_upload_yn: "yes",
    item_acc_stock_yn: "yes",
    item_acc_website_yn: "yes",
    size: "yes",
    item_barcode_yn: "yes",
    item_classify_yn: "yes",
    item_gst_per_yn: "yes",

    item_inventory_type_yn: "yes",
    item_pack_type_yn: "yes",
    item_proces_type_yn: "yes",
    item_remark_yn: "yes",
    item_reorder_qty_yn: "yes",
    item_min_qty_yn: "yes",
    item_max_qty_yn: "yes",
    item_warnty_available_yn: "yes",
    item_acc_mul_image_yn: "yes",
    item_acc_batta_yn: "yes"

}